// 导入组件
import zElTable from './z-el-table/index.js';
import zElTableSize from './z-el-table-size/index.js';
import zElForm from './z-el-form/index.js';
import zSearch from './z-search/index.js';
import zDownload from './z-download/index.js';
import zArea from './z-area/index.js';
import zImage from './z-image/index.js';

// 组件列表
const components = [zElTable, zElTableSize, zElForm, zSearch, zDownload, zArea, zImage];

// 定义 install 方法，接收 Vue 作为参数。如果使用 use 注册插件，那么所有的组件都会被注册
const install = (Vue) => {
	// 判断是否安装
	if (!install.installed) {
		// 遍历注册全局组件
		components.forEach(component => {
			Vue.component(component.name, component);
		});
	}
};

// 是否是直接引入文件
if (typeof window !== 'undefined' && window.Vue) {
	install(window.Vue);
}

const ztcVue = {
	install,
	...components,
};

export default ztcVue;
